var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "21",
        viewBox: "0 0 16 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_295_475)" } }, [
        _c("path", {
          attrs: {
            d: "M2.625 0C1.17715 0 0 1.17715 0 2.625V18.375C0 19.8229 1.17715 21 2.625 21H13.125C14.5729 21 15.75 19.8229 15.75 18.375V2.625C15.75 1.17715 14.5729 0 13.125 0H2.625ZM6.5625 13.125H9.1875C11.0004 13.125 12.4688 14.5934 12.4688 16.4062C12.4688 16.7672 12.1734 17.0625 11.8125 17.0625H3.9375C3.57656 17.0625 3.28125 16.7672 3.28125 16.4062C3.28125 14.5934 4.74961 13.125 6.5625 13.125ZM5.25 9.1875C5.25 8.49131 5.52656 7.82363 6.01884 7.33134C6.51113 6.83906 7.17881 6.5625 7.875 6.5625C8.57119 6.5625 9.23887 6.83906 9.73116 7.33134C10.2234 7.82363 10.5 8.49131 10.5 9.1875C10.5 9.88369 10.2234 10.5514 9.73116 11.0437C9.23887 11.5359 8.57119 11.8125 7.875 11.8125C7.17881 11.8125 6.51113 11.5359 6.01884 11.0437C5.52656 10.5514 5.25 9.88369 5.25 9.1875ZM5.90625 2.625H9.84375C10.2047 2.625 10.5 2.92031 10.5 3.28125C10.5 3.64219 10.2047 3.9375 9.84375 3.9375H5.90625C5.54531 3.9375 5.25 3.64219 5.25 3.28125C5.25 2.92031 5.54531 2.625 5.90625 2.625Z",
            fill: "black",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_295_475" } }, [
          _c("rect", {
            attrs: { width: "15.75", height: "21", fill: "white" },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }